<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="page_8"></a>The characters and events of this story are entirely fictitious; they have no relation to any actual persons or events.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Fm02.vue?3cdd1d65